import React, { useEffect, useState } from "react";
import { Navbar } from "@/components/site/Navbar";
import { Footer } from "@/components/site/Footer";
import { PropertyCard } from "@/components/site/PropertyCard";
import { api } from "@/lib/api";

export default function PropertiesPage() {
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/properties");
        setProperties(data);
      } catch {}
      setLoading(false);
    })();
  }, []);

  return (
    <div className="App">
      <Navbar />

      <section className="max-w-7xl mx-auto px-6 md:px-12 py-16" data-testid="properties-page">
        <div className="label-uppercase">Available now</div>
        <h1 className="h1 text-5xl md:text-6xl mt-4 max-w-3xl">All our Hull rentals,<br/> in one place.</h1>
        <p className="mt-6 text-lg text-[var(--text-secondary)] max-w-2xl">
          Hand-picked homes in Hull's HU5 student belt — walkable to the University of Hull and Newland Avenue.
        </p>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="properties-list-grid">
          {loading ? (
            Array.from({ length: 3 }).map((_, i) => (
              <div key={i} className="aspect-[4/3] bg-[var(--bg-secondary)] animate-pulse" />
            ))
          ) : properties.length === 0 ? (
            <div className="col-span-full text-[var(--text-secondary)]">No properties yet.</div>
          ) : (
            properties.map((p, idx) => <PropertyCard key={p.id} property={p} index={idx} />)
          )}
        </div>
      </section>

      <Footer />
    </div>
  );
}
